const {registerLinkResolver} = require('gatsby-source-prismic-graphql');
const {linkResolver} = require('./src/utils/linkResolver');

registerLinkResolver(linkResolver);

if (process.env.NODE_ENV === 'development') {
  void import('react-grab');
  // POST copied component context to the local MCP server (localhost:4723)
  // so Claude Code's react-grab-mcp tool can read it. No-op if server's down.
  void import('./src/utils/react-grab-mcp').then(({attachMcpPlugin}) => attachMcpPlugin());
}
